import React from 'react'
import {BsCheck}  from 'react-icons/bs'
export default function Websection7box() {
  return (
        <div className="websection7__bottom__right__right">
            <BsCheck color='#701FFF'  />
            <p className='websection7__bottom__right__left'>
            لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است
            </p>
        </div>
  )
}
